module.exports = __webpack_public_path__ + "static/media/hamburger.6c348070.svg";